import { render, staticRenderFns } from "./Card.component.vue?vue&type=template&id=b248416c&scoped=true"
import script from "./Card.component.vue?vue&type=script&lang=js"
export * from "./Card.component.vue?vue&type=script&lang=js"
import style0 from "./Card.component.vue?vue&type=style&index=0&id=b248416c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b248416c",
  null
  
)

export default component.exports